module.exports = __webpack_public_path__ + "static/media/Circles-amico.a32bba47.svg";